import { useEffect } from "react";
import AOS from "aos";
import CardServices from "./components/card_services2";
import Breadcum from "../../../components/breadcum";

const servicesData = [
  {
    text: "Vigilancia y Protección",
    desc: "Brindamos seguridad para proteger la integridad de personas y propiedades con medidas preventivas y personal capacitado.",
    ul1: "Supervisión y monitoreo en tiempo real.",
    ul2: "Protección de bienes, residencias y empresas.",
    ul3: "Seguridad especializada para eventos y corporativos",
    img: "/img/landing/services/service1.webp",
  },
  {
    text: "Capacitación Especializada",
    desc: "Entrenamos a nuestros agentes para garantizar su eficiencia en la protección de nuestros clientes.",
    ul1: "Técnicas avanzadas de seguridad y control de accesos.",
    ul2: "Capacitación en manejo de emergencias y primeros auxilios.",
    ul3: "Formación en normativa legal y protocolos de seguridad.",
    img: "/img/landing/services/service3.webp",
  },
  {
    text: "Seguridad Empresarial",
    desc: "Creamos planes de seguridad estratégicos para prevenir riesgos y garantizar entornos laborales seguros.",
    ul1: "Auditorías de seguridad y supervisión continua.",
    ul2: "Desarrollo de planes de contingencia personalizados.",
    ul3: "Implementación de sistemas de control de acceso y vigilancia.",
    img: "/img/landing/services/service2.webp",
  },
];

export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });
    AOS.refresh();
  }, []);

  return (
    <section
      className="mx-auto max-w-screen-2xl px-6 lg:px-8 py-36"
      id="servicios"
    >
      <div className="text-left mx-auto" data-aos="fade-up">
        <Breadcum text="Nuestros Servicios" />

        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight">
          Soluciones Integrales en seguridad privada
        </h1>
        <p className="text-lg mt-4 text-gray-600 leading-relaxed">
          En Border Protect Seguridad Privada, ofrecemos soluciones integrales
          de protección diseñadas para salvaguardar lo que más importa. Nuestra
          experiencia y profesionalismo nos permiten garantizar la seguridad de
          personas, bienes e instalaciones con estrategias personalizadas y
          equipos altamente capacitados.
        </p>
      </div>

      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-16">
        {servicesData.map((service, index) => (
          <div key={index} data-aos="fade-up" data-aos-delay={`${index * 200}`}>
            <CardServices
              text={service.text}
              desc={service.desc}
              img={service.img}
              ul1={service.ul1}
              ul2={service.ul2}
              ul3={service.ul3}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
